import { renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "modal-backdrop",
    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.close()), ["prevent"])),
    onMousedown: _cache[3] || (_cache[3] = ($event: any) => (_ctx.pressing())),
    onMousemove: _cache[4] || (_cache[4] = ($event: any) => (_ctx.moving()))
  }, [
    _createElementVNode("div", {
      class: "modal",
      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("header", null, [
        _renderSlot(_ctx.$slots, "header", {}, undefined, true),
        (_ctx.showCloseButton)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('toggle')), ["stop","prevent"]))
            }, " X "))
          : _createCommentVNode("", true)
      ]),
      _renderSlot(_ctx.$slots, "body", {}, undefined, true),
      _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
    ])
  ], 544)), [
    [_vShow, _ctx.isOpen]
  ])
}